import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../../../pages/placeholder/placeholder-page.component';

@Component({
  selector: 'app-file-import-calculator',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="calculatorList.file.title" 
      icon="construction"
      >
    </app-placeholder-page>
  `
})
export class FileImportCalculatorComponent {}